import { render, staticRenderFns } from "./ECharts.vue?vue&type=template&id=3888162d&scoped=true"
import script from "./ECharts.vue?vue&type=script&lang=js"
export * from "./ECharts.vue?vue&type=script&lang=js"
import style0 from "./ECharts.vue?vue&type=style&index=0&id=3888162d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888162d",
  null
  
)

export default component.exports